import component from './component';
import { connect } from 'react-redux';
import gql from './gql';
import { triggerInsuranceValidationChanged } from './actions';

export const mapDispatchToProps = {
    triggerInsuranceValidationChanged,
};

function withInsuranceValidation(WrappedComponent) {
    return connect(null, mapDispatchToProps)(gql(component(WrappedComponent)));
}

export default withInsuranceValidation;
